import axios from 'axios';

export const KAKAO_KEY = '70dbc34b3d7188443dd3dd5bbbd6ccca';
export const NAVER_KEY = '8dNFwefUEurhUrKP0ixP';
export const GOOGLE_KEY = '1041756856634-0r5g0m14alamlds7pi05a9elbth4oek7.apps.googleusercontent.com';
export const NAVER_CALLBACK = 'http://www.doowon.net/#/';
export const API_URL = 'http://api.doowon.net';

export const normalise = (value, total) => {
  return ((value - 0) * 100) / (total - 0);
};

export const optionsCity = [
  { value: '서울특별시', label: '서울특별시' },
  { value: '경기도', label: '경기도' },
  { value: '인천광역시', label: '인천광역시' },
  { value: '강원도', label: '강원도' },
  { value: '충청북도', label: '충청북도' },
  { value: '충청남도', label: '충청남도' },
  { value: '전라북도', label: '전라북도' },
  { value: '대전광역시', label: '대전광역시' },
  { value: '광주광역시', label: '광주광역시' },
  { value: '전라남도', label: '전라남도' },
  { value: '경상북도', label: '경상북도' },
  { value: '대구광역시', label: '대구광역시' },
  { value: '경상남도', label: '경상남도' },
  { value: '울산광역시', label: '울산광역시' },
  { value: '부산광역시', label: '부산광역시' },
  { value: '제주도', label: '제주도' },
];

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 1000 * 30,
  headers: { Pragma: 'no-cache', CacheControl: 'no-cache', Expires: '0', Authorization: `${localStorage.getItem('st_token')}` },
});

axiosInstance.interceptors.request.use(
  function (config) {
    const token = `${localStorage.getItem('st_token')}`;
    config.headers.Authorization = token;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },

  function (error) {
    console.error('axiosInstance', error);
    const orgRequest = error.config;
    if (error.response && error.response.status === 401) {
      console.log('토큰 만료');
      orgRequest._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');
      return axios
        .post(API_URL + '/refresh', {
          refreshToken: refreshToken,
          userId: localStorage.getItem('loggedin'),
        })
        .then((res) => {
          console.log(res);
          if (res.status === 201) {
            console.log(res.data);
            localStorage.setItem('st_token', res.data.token);
            const userinfo = res.data.userInfo;
            let buff = {
              name: userinfo.name,
              course: userinfo.course,
              stamp: userinfo.stamp,
            };
            localStorage.setItem(`${userinfo.id}_status`, JSON.stringify(buff));
            localStorage.setItem('st_token', res.data.token);
            localStorage.setItem('refreshToken', res.data.refreshToken);
            orgRequest.headers['Authorization'] = res.data.token;
            return axios(orgRequest);
          } else {
            console.log('로그인 필요');
            window.location.href = '/#/login';
          }
        })
        .catch((err) => {
          console.log('로그인 필요 :: catch');
          localStorage.removeItem(`${localStorage.getItem('loggedin')}_status`);
          localStorage.removeItem('loggedin');
          localStorage.clear();
          console.log(err.message);
        });
    } else {
      window.location.href = '/#/login';
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
